import React from "react";
import YouTube from 'react-youtube';

import Header from '../../header';
import Footer from '../../footer';

import PhotoGallery from '../../components/PhotoGallery';
import LoadingSpinner from '../../components/spinner/LoadingSpinner';
import ApplicationFormGoalkeepersDay from '../../components/forms/ApplicationFormGoalkeepersDay';
import {getCampIntroduction, loadCampsDataAndRender, loadPhotoGalleryImages, getPhotosFromGallery} from './CampsUtil';

const eventName = "Den Brankářů";

export default class GoalkeepersDay extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      photoUrl: undefined,
      campsData: [],
      photoGallery: [],
      isLoading: true,
    };
  }

  componentDidMount(){
      loadCampsDataAndRender("goalkeepers_day_camps", this);
      loadPhotoGalleryImages("goalkeepers_day_camps", eventName, this);
  }

  render() {
    const {campsData, isLoading, isIntroLoading, photoUrl, photoGallery} = this.state;
    const hideHeaderAndFooter = this.props.hideHeaderAndFooter;

    let campIntroduction = undefined;
    let isPhotoGalleryLoading = true;

    if(campsData.length > 0) {
      campIntroduction = campsData[0];
      let numberOfGalleriesToLoad = campIntroduction.number_of_galleries !== undefined ? campIntroduction.number_of_galleries : 0;
      isPhotoGalleryLoading = (photoGallery.length < numberOfGalleriesToLoad);
      console.log("Number of photoGallery to load: " + numberOfGalleriesToLoad);
      console.log("Loaded photoGalleries: " + photoGallery.length);
    }

    const opts = {
     height: '450',
     width: '100%',
     playerVars: { // https://developers.google.com/youtube/player_parameters
       autoplay: 0
     }
   };

   let loading = isLoading || isIntroLoading || isPhotoGalleryLoading

   return loading ? (
           <LoadingSpinner loadingState={loading} />
       ) : (
      <div>
            {hideHeaderAndFooter ? '' : <Header />}
		        <div className="view textArticle camps">
              {getCampIntroduction(campIntroduction, photoUrl)}

              <p>
              🧤🔥 10. ROČNÍK BRANKÁŘSKÝCH SOUBOJŮ JE TADY! 🔥🧤
              </p>

              <p>
                Jubilejní oranžové šílenství klepe na dveře - <a href='https://just4keepers.dtap.cz/register/?link=22'>přihláška zde.</a>
              </p>

              <p>
                Deset let. Deset ročníků. Stovky brankářů. Tisíce zákroků. Nespočet emocí. A letos? Bude to největší, nejhlasitější a nejenergičtější ročník v historii! 💥
              </p>

              <p>
                📅 21. 6. | Luka nad Jihlavou
              </p>

              <p>
                Připrav se na 10. jubilejní ročník Brankářských válek 1vs1, kde se opět sejde elita mladých i dospělých brankářů a brankářek z celé republiky.
              </p>


              <p>

              <ul class="goalkeeper-day-li">
                ⚔️ CO TĚ ČEKÁ?
              <li>
                ✅ Souboje 1vs1 před plnými tribunami
              </li>
              <li>
                ✅ Jedinečná atmosféra
              </li>
              <li>
                ✅ Fanoušci, rodiče, trenéři i speciální hosté - budou autogramy
              </li>
              <li>
                ✅ Doprovodný program pro celé rodiny
              </li>
              <li>
                ✅ Soutěžní dres i překvapení pro doprovod
              </li>
              <li>
                ✅ Oběd, svačina a pitný režim v ceně
              </li>
              <li>
              ✅ Hodnotné ceny pro umístěné
              </li>
              </ul>
              </p>

              <p>
                Tohle není jen turnaj. Tohle je <b>brankářský svátek roku</b>.
              </p>

              <p>
🧡 PROČ PŘIJET?
              </p>

              <p>
Protože být brankář znamená být jiný. Odvážnější, šílenější, silnější. A tady budeš mezi svými.
              </p>

              <p>
Porovnáš, zažiješ radost, emoce, tlak, přátelství, které ti běžný zápas nedá.
              </p>

              <p>
💰 STARTOVNÉ - 1000 Kč
              </p>


              <p>
⚠️ Bereme pouze 25 prvních brankářů/brankářek v každé kategorii!
              </p>

              <p>
SOUTĚŽNÍ KATEGORIE- 2017 a mladší, 2015 – 2016, 2013 – 2014, 2011 – 2012, 2010 a starší
              </p>

              <p>
🎉 10 LET SPOLU
              </p>

              <p>
Není to jen o vítězích, je to o všech, kteří u toho byli posledních 10 let a budou v těch následujících.
Neváhej, místa mizí rychle.
              </p>

              <p>
📣 Roztrub to do světa! Sdílej, pošli kamarádům, trenérům, rodičům. Ať je 10. ročník opravdu legendární.
              </p>

              <p>
Těšíme se na každého z vás 🧡
              </p>

              <p>
P.S. Nejedeš jen jako soutěžící? Nevadí! Součástí akce bude opět <b>doprovodný program, který si užijete :) </b>
              </p>


              <h4> <a href='https://just4keepers.dtap.cz/register/?link=22'>Online přihláška - klikni zde</a></h4>


              <div className="indent">
                  <p>
                    {campIntroduction.videoNote}
                  </p>

                  <div className="responsive left">
                  {
                    campIntroduction.videoYoutubeIds.map((videoId, index) => (
                      <div className={"column-" + ((index % 3 ) + 1) }>
                        <YouTube
                          videoId={videoId}
                          opts={opts}
                          onReady={this._onReady}
                          />
                      </div>
                    ))
                   }
                  </div>
                </div>

                <PhotoGallery photos={getPhotosFromGallery(eventName, photoGallery)}/>

              </div>

            {hideHeaderAndFooter ? '' : <Footer />}
      </div>
    );
  }

}
